import apiClient from "../../../services/apiClient";

export const permissionsApi = {
  async loadPermissions(groupId, groupName) {
    const encodedGroupName = encodeURIComponent(groupName);

    const response = await apiClient.get(
      `/Permissions/${groupId}/${encodedGroupName}`,
      {
        headers: {
          accept: "*/*",
        },
      }
    );
    return response.data;
  },

  async savePermissions(requestBody, groupId, groupName) {
    const encodedGroupName = encodeURIComponent(groupName);

    const response = await apiClient.put(
      `/Permissions/${groupId}/${encodedGroupName}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      }
    );

    return response.data;
  },

  async importPermissions(fromGroup, toGroup) {
    const response = await apiClient.put(
      "/Permissions/import-permissions",
      {
        fromGroup: fromGroup,
        toGroup: toGroup,
      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
        },
      }
    );

    return response.data;
  },
};
